<script lang="ts" setup>
import { SlimBanner } from '~/types/Content'

const props = defineProps<SlimBanner>()

const textColour = props.supportingData?.home?.variant?.children?.textColour?.value || 'dark'
const alignment = props.supportingData?.home?.variant?.children?.alignment?.value || 'left'
</script>

<template>
  <section class="collection-banner" :class="[`collection-banner--${alignment}`, `collection-banner--${textColour}`]">
    <Picture v-if="picture" class="collection-banner__media" v-bind="picture" />
    <div class="collection-banner__content">
      <h2 v-if="heading" class="collection-banner__heading">{{ heading }}</h2>
      <RichText v-if="content" class="collection-banner__body" :document="content" />
      <Action v-if="link" v-bind="link" />
    </div>
  </section>
</template>

<style lang="postcss">
.collection-banner {
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: var(--component-space);
  padding: var(--space-70) var(--space-50);
  max-width: var(--container-max-width);
  margin-inline: auto;
  min-height: 12.5rem;

  @media (--tablet) {
    align-items: center;
  }

  @media (--desktop) {
    padding: var(--space-70) var(--space-60);
  }

  &.collection-banner--left {
    justify-content: flex-start;
    padding-right: var(--space-120);

    .collection-banner__content {
      text-align: left;
      align-items: flex-start;
    }
  }

  &.collection-banner--center {
    justify-content: center;

    .collection-banner__content {
      text-align: center;
      align-items: center;
    }
  }

  &.collection-banner--right {
    justify-content: flex-end;
    padding-left: var(--space-120);

    .collection-banner__content {
      text-align: left;
      align-items: flex-start;
    }
  }

  &.collection-banner--light {
    color: var(--text-reverse);
  }

  &.collection-banner--dark {
    color: var(--text-primary);
  }

  .collection-banner__media {
    display: block;
    position: absolute;
    inset: 0;
    z-index: 0;

    .picture-container,
    .picture {
      width: 100%;
      height: 100%;
    }

    .picture__img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .collection-banner__content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: var(--space-50);
    max-width: 26rem;

    @media (--desktop) {
      max-width: 30rem;
    }
  }

  .collection-banner__heading {
    font-family: var(--font-display);
    font-size: 1.75rem;
    font-weight: 300;
    text-transform: none;
    margin-bottom: 0;

    @media (--desktop) {
      font-size: 2.25rem;
    }
  }

  .collection-banner__body {
    & p:last-of-type {
      margin-bottom: 0;
    }
  }

  .action-wrapper {
    @media (--desktop) {
      padding-top: var(--space-30);
    }
  }
  .button-primary,
  .button-secondary,
  .button-secondary-reverse {
    padding-inline: var(--space-100);
  }
}
</style>
